import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { authAxios } from "../utils";
import {
  Row,
  Col,
  Button,
  Card,
  Form,
  DatePicker,
  Select,
  Spin,
  Popover,
  List,
} from "antd";
import {
  userIDURL,
  viewReports,
  listBophanxuly,
  exportExcelReport,
} from "../constants";
import { Column, Pie, Line } from "@ant-design/charts";
import moment from "moment";
// import Cookies from 'universal-cookie';
// const cookies = new Cookies()
import Cookies from "universal-cookie";
import { useMediaQuery } from "react-responsive"; //npm install react-responsive --save

const cookies = new Cookies();
const { RangePicker } = DatePicker;
const rangeConfig = {
  rules: [
    {
      type: "array",
      required: true,
      message: "Vui lòng chọn thời gian!",
    },
  ],
};
const DateFormat = "DD/MM/YYYY";
const customFormat = (value) => `${value.format(DateFormat)}`;

function disabledDate(current) {
  // Can not select days before today and today
  return current && current > moment().endOf("day");
}
const ColumnTyLeDungHan = (value) => {
  const dataT =
    Object.entries(value.data).length > 0
      ? Object.entries(value.data).map(([key, value]) => ({
          type: key,
          value: value[0],
          info: { valueItem: value[1], all: value[2] },
        }))
      : [{}];

  const config = {
    data: dataT,
    xField: "type",
    yField: "value",
    yAxis: {
      min: 0,
      max: 100,
      visible: true,
      label: {
        style: {
          fill: "#292929",
        },
      },
    },
    xAxis: {
      label: {
        // autoHide: true,
        // autoRotate: false,
        style: {
          fill: "#292929",
        },
      },
    },
    color: "#0070c0",
    label: {
      position: "middle",
      style: {
        fill: "#FFFFFF",
        opacity: 0.6,
        fontWeight: 600,
        fontSize: 14,
      },
    },
    meta: {
      type: {
        alias: "Thể loại",
      },
      value: {
        alias: "",
        formatter: (v) => {
          return `${v}%`;
        },
      },
    },
    tooltip: {
      // formatter: (data) => {
      //   // return `<div>a</div>`;
      //   return { name: "Tỷ lệ %", value: data.value + '%' };
      // },
      customContent: (title, items) => {
        return (
          <>
            <h5 style={{ marginTop: 16 }}>{title}</h5>
            <ul style={{ paddingLeft: 0 }} className="g2-tooltip-list">
              {/* {items?.map((item, index) => { */}
              {items.map((item, index) => {
                const { valueItem, all } = item.data.info;
                return (
                  <li
                    className="g2-tooltip-list-item"
                    style={{
                      marginBottom: 4,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <span className="g2-tooltip-marker"></span>
                    <span style={{ display: "inline-flex", flex: 1 }}>
                      <span style={{ marginRight: 3 }}>{valueItem}/</span>
                      <span className="g2-tooltip-list-item-value">
                        {all} ({item.data.value}%)
                      </span>
                    </span>
                  </li>
                );
              })}
            </ul>
          </>
        );
      },
      // customContent: (title, data) => {
      //   return `<div>${title}</div>`;
      // }
    },
    columnWidthRatio: 0.1,
    style: {
      fontWeight: 600,
    },
  };

  return <Column {...config} />;
};
const ColumnYeuCauXuLyLai = (value) => {
  const data =
    Object.entries(value.data).length > 0
      ? Object.entries(value.data).map(([key, value]) => ({
          type: key,
          value: value,
        }))
      : [{}];

  const config = {
    data: data,
    xField: "type",
    yField: "value",
    color: "#0070c0",
    columnWidthRatio: 0.1,
    label: {
      position: "middle",
      layout: [
        { type: "interval-adjust-position" },
        { type: "interval-hide-overlap" },
        { type: "adjust-color" },
      ],
    },
  };

  return <Column {...config} />;
};
const ColumnYeuCauHuy = (value) => {
  const data1 = Object.entries(value.data).map(([key, value]) => ({
    type: key,
    name: "BP",
    value: value[0],
  }));
  const data2 = Object.entries(value.data).map(([key, value]) => ({
    type: key,
    name: "Auto",
    value: value[1],
  }));
  const data = data1.concat(data2);
  const config = {
    data: data,
    isGroup: true,
    xField: "type",
    yField: "value",
    seriesField: "name",
    color: ["#0070c0", "#FF2929"],
    label: {
      position: "middle",
      layout: [
        { type: "interval-adjust-position" },
        { type: "interval-hide-overlap" },
        { type: "adjust-color" },
      ],
    },
  };

  return <Column {...config} />;
};
const PieTyLeDamNhan = (value) => {
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const isPortrait = useMediaQuery({ query: "(orientation: portrait)" });
  const isRetina = useMediaQuery({ query: "(min-resolution: 2dppx)" });
  // console.log(isDesktopOrLaptop);
  const data =
    Object.entries(value.data).length > 0
      ? Object.entries(value.data).map(([key, value]) => ({
          type: key,
          value: value,
        }))
      : [{}];

  const config = {
    data: data,
    angleField: "value",
    colorField: "type",
    // color: ['#ffc000', '#00b050', '#0070c0','#ff2929','#CC0099','#948a54','#33ccff','#7FFF00','#FF7F50','#00FFFF'],
    color: [
      "#ffc000",
      "#00b050",
      "#0046c8",
      "#ff2929",
      "#cc0099",
      "#948a54",
      "#33ccff",
      "#7f7f7f",
      "#bcbd22",
      "#17becf",
    ],
    radius: 0.9,
    label: {
      // type: isDesktopOrLaptop ? "spider" : "inner",
      type: "inner", //'inner' | 'outer' | 'spider'
      // offset: '-30%',
      content: function content(_ref) {
        const percent = _ref.percent;
        return "".concat((percent * 100).toFixed(1), "%");
      },
      style: {
        fontSize: 14,
        textAlign: "center",
        // fill: 'red'
        // shadowColor: 'red',
        // shadowBlur: 10,
      },
    },
    interactions: [{ type: "element-active" }],
    pieStyle: {
      // node_modules\@antv\g-base\lib\types.d.ts
      // shadowColor: "yellow",
      // shadowBlur: 30,
      // stroke: 'yellow',
      // lineWidth: 10,
      // strokeOpacity: 10,
      // lineWidth:10,
      // borderWidth: 10,
      // shadowOffsetX:10,
      // lineCap:"square",
      // lineDash: [4, 5],
      // strokeOpacity: 0.7,
      // shadowColor: 'black',
      // shadowBlur: 10,
    },
    style: {
      // backgroundColor: "red",
    },

    // state: {
    //   active: {
    //     style: {
    //       shadowColor: 'yellow',
    //       shadowBlur: 4,
    //       stroke: 'transparent',
    //       fill: 'red',
    //     },
    //   },
    // },

    legend: {
      // position: 'right-top',
      // layout: 'horizontal',
      // offsetX: 8,
      // title: {
      //   text: 'ABC',
      //   spacing: 8,
      // },
      // itemName: {
      //   style: {
      // opacity: 0.65,
      // fill: 'red',
      //     fontSize: 20,
      //   },
      // },
      // itemValue: {
      //   formatter: (text, item) => {
      //     const items = data.filter((d) => d.type === item.value);
      //     return items.length ? items.reduce((a, b) => a + b.value, 0) / items.length : '-';
      //   },
      //   style: {
      //     opacity: 0.65,
      //     fill: 'red'
      //   },
      // },
    },
  };

  return <Pie {...config} />;
};

const ContentDetail = ({ dataDetail }) => {
  // if (dataDetail.list_code.length > 0){
  return (
    <List
      itemLayout="horizontal"
      dataSource={dataDetail.list_code}
      className="list-report"
      // style={{ maxHeight: "200px", overflowY: "auto" }}
      renderItem={(item) => (
        <List.Item style={{ padding: "0px" }}>
          <List.Item.Meta
            title={
              <a
                href={"/tickets/" + item[1]}
                target="_blank"
                style={{ color: "rgb(49 150 245)" }}
              >
                {item[0]}
              </a>
            }
            // description={<a style={{color:'#ff0000'}}>{item[1]}</a>}
          />
          {/* {item[0]} */}
        </List.Item>
        // {<List.Item.Meta
        //     title={<a>{item[0]}</a>}
        //     description={<a style={{color:'#ff0000'}}>{item[0]}</a>}
        //   />
        // </List.Item>}
      )}
    />
  );
  // }
};

// return (
//     dataList_LikePost.map((item_like, index_like) => ( 3a83ef
//         <div key = {'like_post_' + item_like.username}>
//             <Row style={{ cursor: "default" }}>
//                 {item_like.avatar ? <Avatar src={item_like.avatar}/> : <UserOutlined/>}
//                 &nbsp;<span>{item_like.username}</span>
//             </Row>
//         </div>
//     ))
// )

const BoxThongKe = (value) => {
  const data = Object.entries(value.data).map(([key, value]) => ({
    name: key,
    value: value.count,
  }));

  return (
    <Row gutter={[8, 8]} style={{ justifyContent: "center" }}>
      {data.map((item, index) => (
        // <Col xs={8} md={8} lg={8} xl={8} sm={12} key={index}>

        <Popover
          content={
            <ContentDetail dataDetail={Object.entries(value.data)[index][1]} />
          }
          title="Danh sách chi tiết "
          placement="bottom"
          // placement = {index == 0 ? "bottomLeft" : (index == data.length-1 ? "bottomRight" : "bottom")}
          key={index}
          overlayClassName="pop-report"
        >
          <Col xl={6} sm={8} key={index}>
            <Card
              style={{ textAlign: "center", cursor: "pointer" }}
              bodyStyle={{ padding: "12px" }}
            >
              <h5>{item.name}</h5>
              <h4>{item.value}</h4>
            </Card>
          </Col>
        </Popover>
      ))}
    </Row>
  );
};
const LineTyLeLoaiYeuCau = (value) => {
  const data =
    Object.entries(value.data).length > 0
      ? Object.entries(value.data).map(([key, value]) => ({
          type: key,
          value: value[0],
          info: { valueItem: value[1], all: value[2] },
        }))
      : [{}];
  // const data = value.data.map((item,index) => ({
  //     'type':item[0],
  //     'value':item[1][0],
  //     'info':{'valueItem':item[1][1],'all':item[1][2]},
  // }))
  const config = {
    data: data,
    xField: "type",
    yField: "value",
    yAxis: {
      min: 0,
      max: 100,
      visible: true,
      label: {
        style: {
          fill: "#292929",
        },
      },
    },
    xAxis: {
      label: {
        style: {
          fill: "#292929",
        },
      },
    },
    meta: {
      type: {
        alias: "Thể loại",
      },
      value: {
        alias: "Tỷ lệ %",
        formatter: (v) => {
          return `${v}%`;
        },
      },
    },
    tooltip: {
      customContent: (title, items) => {
        return (
          <>
            <h5 style={{ marginTop: 16 }}>{title}</h5>
            <ul style={{ paddingLeft: 0 }} class="g2-tooltip-list">
              {items?.map((item, index) => {
                const { valueItem, all } = item.data.info;
                return (
                  <li
                    key={item.year}
                    className="g2-tooltip-list-item"
                    data-index={index}
                    style={{
                      marginBottom: 4,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <span className="g2-tooltip-marker"></span>
                    <span style={{ display: "inline-flex", flex: 1 }}>
                      <span style={{ marginRight: 1 }}>{valueItem}/</span>
                      <span className="g2-tooltip-list-item-value">
                        {all} ({item.data.value}%)
                      </span>
                    </span>
                  </li>
                );
              })}
            </ul>
          </>
        );
      },
    },
    label: {},
    point: {
      size: 5,
      shape: "diamond",
      style: {
        fill: "white",
        stroke: "#5B8FF9",
        lineWidth: 2,
      },
    },
    state: {
      active: {
        style: {
          shadowColor: "yellow",
          shadowBlur: 4,
          stroke: "transparent",
          fill: "red",
        },
      },
    },
    theme: {
      geometries: {
        point: {
          diamond: {
            active: {
              style: {
                shadowColor: "#FCEBB9",
                shadowBlur: 2,
                stroke: "#F6BD16",
              },
            },
          },
        },
      },
    },

    interactions: [{ type: "marker-active" }],
  };
  return <Line {...config} />;
};

class TicketReport extends React.Component {
  state = {
    loading: false,
    lsDictTyLeDamNhan: [],
    lsDictTyLeDungHan: [],
    lsBoxThongKe: [],
    lsTyLeLoaiYeuCau: [],
    lsYeuCauHuy: [],
    lsYeuCauXuLyLai: [],
    lsBophan: [],
    // currentBophan: 0,
    fromdate: new Date(),
    todate: new Date(),
    // dateNow: [moment("2021-09-01", "YYYY-MM-DD"), moment("2021-09-08", "YYYY-MM-DD").add(7, 'days')],
    dateNow: [moment(new Date()).subtract(7, "days"), moment(new Date())],
  };

  componentDidMount() {
    this.fetchListBpxl({
      columnSort: "id",
      typeSort: "ascend",
      is_active: true,
      page_size: "1000",
      page: "1",
    });

    this.handleFetchUserInfo()
      .then((res) => {
        //   var filter_lsBophan = Object.keys(res.data.handlingPermission).includes('AD') ? this.state.lsBophan : this.state.lsBophan.filter((d) => d.is_manager == res.data.infoUser[0] )
        //   this.setState({
        //       lsBophan: filter_lsBophan,
        //       currentBophan:filter_lsBophan[0].name,
        //   });
        this.fetchReport_view({
          startdate: moment(this.state.dateNow[0]._d).format("YYYY-MM-DD"), // dateNow YYYY-MM-DD
          enddate: moment(this.state.dateNow[1]._d).format("YYYY-MM-DD"),
          handlinggroup: this.state.lsBophan[0].id,
        });
      })
      .catch((err) => {
        this.setState({ error: err, loading: false });
      });
  }

  fetchListBpxl = (params = {}) => {
    this.setState({ loading: true });
    authAxios(cookies.get("token"))
      .get(listBophanxuly, { params: params })
      .then((res) => {
        // 050624 Được view all DS bộ phận xử lý
        var active_lsBophan = res.data.results.filter(
          (item) => item.is_active == true
        );
        this.setState({
          lsBophan: active_lsBophan,
          defaultBophan: active_lsBophan[0].id,
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({ error: err, loading: false });
        if (err.response.status === 401) {
          this.props.history.push("/login");
        }
      });
  };

  handleFetchUserInfo = () => {
    return authAxios(cookies.get("token")).get(userIDURL);
  };

  fetchReport_view = (params = {}) => {
    var FormData = require("form-data");
    var data = new FormData();
    data.append("startdate", params.startdate); //YYYY-MM-DD
    data.append("enddate", params.enddate);
    data.append("handlinggroup", params.handlinggroup);
    authAxios(cookies.get("token"))
      .post(viewReports, data)
      .then((res) => {
        this.setState({
          dateNow: [
            moment(params.startdate, "YYYY-MM-DD"),
            moment(params.enddate, "YYYY-MM-DD"),
          ],
          defaultBophan: params.handlinggroup,

          lsBoxThongKe: res.data.dict_bieudo_01,
          lsDictTyLeDamNhan: res.data.dict_bieudo_02,
          lsDictTyLeDungHan: res.data.dict_bieudo_03,
          lsTyLeLoaiYeuCau: res.data.dict_bieudo_04,
          // lsYeuCauHuy:res.data.Report_05,
          // lsYeuCauXuLyLai:res.data.Report_06
        });
      })
      .catch((err) => {
        this.setState({ error: err, loading: false });
      });
  };

  fileDownload = () => {
    const fnFileDownload = require("js-file-download");
    const { defaultBophan, currentBophan, dateNow } = this.state;
    const filename =
      this.state.currentBophan +
      "_" +
      moment(dateNow[0]._i, "YYYY-MM-DD").format("YYYYMMDD") +
      "_" +
      moment(dateNow[1]._i, "YYYY-MM-DD").format("YYYYMMDD") +
      ".xlsx";
    var FormData = require("form-data");
    var data = new FormData();
    data.append("startdate", dateNow[0]._i); //YYYY-MM-DD
    data.append("enddate", dateNow[1]._i);
    data.append("handlinggroup", defaultBophan);
    authAxios(cookies.get("token"))
      .post(exportExcelReport, data, { responseType: "blob" })
      .then((res) => {
        fnFileDownload(res.data, filename);
      });
  };

  isValidDate(d) {
    var r = /^(\d{4})\-(\d{1,2})\-(\d{1,2})$/; //YYYY-MM-DD
    return r.test(d) & !isNaN(new Date(d).getTime());
  }

  onFinish = (values) => {
    // this.fetchReport({
    //     fromdate:moment(values['datepicker'][0]).format('L'),
    //     todate:moment(values['datepicker'][1]).format('L'),
    //     bophan:values.bophanxuly,
    // })

    if (this.isValidDate(values.datepicker[0]._i)) {
      //YYYY-MM-DD auto refresh
      this.fetchReport_view({
        startdate: values.datepicker[0]._i, //datepicker DD/MM/YYYY
        enddate: values.datepicker[1]._i,
        handlinggroup: values.bophanxuly,
      });
    } else {
      // submit tra cứu
      this.fetchReport_view({
        startdate: moment(values.datepicker[0]._i, "DD/MM/YYYY").format(
          "YYYY-MM-DD"
        ), //datepicker DD/MM/YYYY
        enddate: moment(values.datepicker[1]._i, "DD/MM/YYYY").format(
          "YYYY-MM-DD"
        ),
        handlinggroup: values.bophanxuly,
      });
    }

    // this.setState({
    // loading:true,currentBophan:this.state.currentBophan,
    // fromdate:moment(values['datepicker'][0]).format('YYYYMMDD'),
    // todate:moment(values['datepicker'][1]).format('YYYYMMDD')
    // dateNow: [moment(moment(params.startdate).format('DD/MM/YYYY'), "DD/MM/YYYY"), moment(moment(params.enddate).format('DD/MM/YYYY'), "DD/MM/YYYY")],
    // })
    // setTimeout(() => {
    //     this.setState({loading:false})
    // }, 1000);
  };

  formLayout = (data) => {
    const [form] = Form.useForm();
    useEffect(() => {
      // var setDateFomate = [moment(data.dateNow[0]._i, "DD/MM/YYYY"), moment(data.dateNow[1]._i, "DD/MM/YYYY")]
      // if (moment(data.dateNow[0]._i, "DD/MM/YYYY")._d == "Invalid Date") {
      //   setDateFomate = [moment(data.dateNow[0]._i, "YYYY-MM-DD"), moment(data.dateNow[1]._i, "YYYY-MM-DD")]
      // }
      var setDateFomate = [
        moment(data.dateNow[0]._d, "YYYY-MM-DD"),
        moment(data.dateNow[1]._d, "YYYY-MM-DD"),
      ];
      form.setFieldsValue({
        bophanxuly: data.defaultBophan,
        datepicker: setDateFomate,
      });
    });
    const setCurrentBp = (value) => {
      // console.log(value);
      this.setState({
        loading: false,
        defaultBophan: value.value,
        currentBophan: value.children,
      });
      // this.fetchReport_view({
      //   startdate: moment(this.state.dateNow[0]._i),
      //   enddate: moment(this.state.dateNow[1]._i),
      //   handlinggroup: value.value,
      // })
    };
    const setRangeDate = (value) => {
      form.setFieldsValue({
        datepicker: [
          moment(value[0], "DD/MM/YYYY"),
          moment(value[1], "DD/MM/YYYY"),
        ],
      });
      //   console.log(value[0]);
      this.setState({
        dateNow: [
          moment(value[0], "DD/MM/YYYY"),
          moment(value[1], "DD/MM/YYYY"),
        ],
      });
      // this.fetchReport_view({
      //   // startdate: moment(value[0]).format('YYYY-MM-DD'),
      //   // enddate: moment(value[1]).format('YYYY-MM-DD'),
      //   handlinggroup: this.state.defaultBophan,
      // })
    };

    // const firstBophan = data.firstBophan
    return (
      <Form onFinish={this.onFinish} form={form}>
        <Row>
          <Col sm={7}>
            <Form.Item label={"Thời gian"} name="datepicker" {...rangeConfig}>
              <RangePicker
                ranges={{
                  "Hôm nay": [moment(), moment()],
                  "Tháng này": [
                    moment().startOf("month"),
                    moment().endOf("month"),
                  ],
                  "Năm nay": [moment().startOf("year"), moment().endOf("year")],
                  "Năm ngoái": [
                    moment().add(-1, "year").startOf("year"),
                    moment().add(-1, "year").endOf("year"),
                  ],
                }}
                format="DD/MM/YYYY"
                //211124 bỏ vì ko có tác dụng
                // initialValues={[
                //   moment(new Date(), "DD/MM/YYYY"),
                //   moment(new Date(), "DD/MM/YYYY").add(7, "days"),
                // ]}
                onChange={(e, value) => setRangeDate(value)}
              />
            </Form.Item>
          </Col>
          <Col sm={1}></Col>
          <Col sm={6}>
            <Form.Item
              label="Bộ phận xử lý"
              name="bophanxuly"
              rules={[{ required: true }]}
            >
              {data.lsBophan.length === 1 ? (
                <Select onChange={(e, value) => setCurrentBp(value)} disabled>
                  {data.lsBophan.map((item, index) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              ) : (
                <Select onChange={(e, value) => setCurrentBp(value)}>
                  {data.lsBophan.map((item, index) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>
          <Col sm={1}></Col>
          <Button type={"primary"} htmlType={"submit"}>
            Tra cứu
          </Button>
          <Button
            type={"danger"}
            className={"btnGreen"}
            style={{ marginLeft: 5 }}
            onClick={this.fileDownload}
          >
            Xuất excel
          </Button>
        </Row>
      </Form>
    );
  };

  render() {
    const {
      loading,
      lsDictTyLeDamNhan,
      lsDictTyLeDungHan,
      lsBoxThongKe,
      lsTyLeLoaiYeuCau,
      lsYeuCauHuy,
      lsYeuCauXuLyLai,
    } = this.state;
    // let {userPermission} = this.props
    return (
      <>
        <this.formLayout {...this.state} />
        <Spin spinning={loading}>
          <Row>
            <Col sm={24}>
              <BoxThongKe data={lsBoxThongKe} />
            </Col>
          </Row>
          <Row>
            <Col sm={10}>
              <Card bodyStyle={{ padding: "12px" }}>
                <h1>
                  <b>Tỷ lệ đảm nhận</b>
                </h1>
                <PieTyLeDamNhan data={lsDictTyLeDamNhan} />
              </Card>
            </Col>
            <Col sm={14}>
              <Card bodyStyle={{ padding: "12px" }}>
                <h1>
                  <b>Tỷ lệ yêu cầu đúng thời hạn</b>
                </h1>
                <ColumnTyLeDungHan data={lsDictTyLeDungHan} />
              </Card>
            </Col>
          </Row>
          <Row style={{ marginTop: 10 }}>
            <Col sm={24}>
              <Card bodyStyle={{ padding: "12px" }}>
                <h1>
                  <b>Tỷ lệ loại yêu cầu</b>
                </h1>
                <LineTyLeLoaiYeuCau data={lsTyLeLoaiYeuCau} />
              </Card>
            </Col>
          </Row>
          {/* <Row style={{marginTop:10}}> */}
          {/* <Col sm={12}>
                        <Card>
                        <h1>Số lượng yêu cầu đã hủy sau khi BP xử lý tiếp nhận</h1>
                        <ColumnYeuCauHuy data={lsYeuCauHuy} />
                        </Card>
                    </Col> */}
          {/* <Col sm={12}>
                        <Card>
                        <h1>Số lượng yêu cầu BP xử lý lại</h1>
                        <ColumnYeuCauXuLyLai data={lsYeuCauXuLyLai} />
                        </Card>
                    </Col> */}
          {/* </Row> */}
        </Spin>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    // refreshCart: () => dispatch(fetchCart())
  };
};
const mapStateToProps = (state) => {
  return {
    userPermission: state.user.userPermission,
  };
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TicketReport)
);
